import { render } from "./gstyjdfp.vue?vue&type=template&id=c94a06da&scoped=true"
import script from "./gstyjdfp.vue?vue&type=script&lang=js"
export * from "./gstyjdfp.vue?vue&type=script&lang=js"

import "./gstyjdfp.vue?vue&type=style&index=0&id=c94a06da&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c94a06da"]])

export default __exports__